import axios from 'axios';
import { noop } from 'ui-components/default-props/noop';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 * @typedef {import('./types/rate-recommendation-api-types').RecommendationSummaryRequest} RecommendationSummaryRequest
 * @typedef {import('./types/rate-recommendation-api-types').BulkRateRecommendationSummary} BulkRateRecommendationSummary
 * @typedef {import('./types/rate-recommendation-api-types').BulkApplyRateRecommendationsRequest} BulkApplyRateRecommendationsRequest
 * @typedef {import('./types/rate-recommendation-api-types').BulkRateRecommendationApplyResponse} BulkRateRecommendationApplyResponse
 */

/**
 * @param {RecommendationSummaryRequest} request
 * @returns {Promise<AxiosResponse<BulkRateRecommendationSummary>>}
 */
export const getSummary = async (request) => {
  return axios.post('rateRecommendations/getSummary', request);
};

/**
 * @param {BulkApplyRateRecommendationsRequest} request
 * @returns {Promise<AxiosResponse<BulkRateRecommendationApplyResponse>>}
 */
export const bulkApply = async (request) => {
  return axios.post('rateRecommendations/bulkApply', request);
};

/**
 * @param {import('./types/rate-recommendation-api-types').SaveShowedRecommendationRequest} request
 * @returns {void}
 */
export const trackShowRecommendation = (request) => {
  axios.post('rateRecommendations/show', request).catch(noop);
};

/**
 * @param {import('./types/rate-recommendation-api-types').SaveAppliedRecommendationRequest} request
 * @returns {void}
 */
export const trackApplyRecommendation = (request) => {
  axios.post('rateRecommendations/apply', request).catch(noop);
};
